import React from 'react';

import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container);

import 'assets/scss/app.scss';
import Root from './Root';
import * as serviceWorker from './serviceWorker';

root.render(
	<React.StrictMode>
		<Root />
	</React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
